module.exports = __webpack_public_path__ + "img/m_pokora-pyramide_tour.12111a60.jpg";